import {v7 as uuidv7} from 'uuid'

import {Attribution} from '../types'

const attributionKeys: Array<keyof Attribution> = ['vtmSrc', 'label', 'vclid']

/**
 * A landing refreshes the attribution when nothing is stored yet, or when a
 * parameter it supplied differs from the stored value. A parameter the landing
 * left out is not a difference: `vtm_src` and `label` travel on internal links
 * while `vclid` is stripped, so a hotel card opened in a new tab matches the
 * store and neither mints a second vclid nor emits a second event.
 */
export const shouldRefreshAttribution = (
  stored: Attribution,
  supplied: Attribution
): boolean =>
  !stored.vclid ||
  attributionKeys.some(key => supplied[key] && supplied[key] !== stored[key])

/**
 * The values a refresh writes. A landing-provided vclid is kept as it arrived;
 * without one the client mints a UUID v7, so every session ends up with a vclid
 * the pipeline can join on.
 */
export const resolveRefreshedAttribution = (
  supplied: Attribution
): Attribution => ({
  vtmSrc: supplied.vtmSrc,
  label: supplied.label,
  vclid: supplied.vclid || uuidv7()
})
